import React from "react";
import { ImageUploadWithPreview, TextAreaCus, TextField } from "components";
import { Controller, useForm } from "react-hook-form";

interface IItemPopup {
    onClose?: () => void;
    onConfirm?: (a: any) => void;
}
export default function Attachment({ onClose, onConfirm }: IItemPopup) {
    const {
        control,
        register,
        handleSubmit,
    } = useForm({ defaultValues: { file: null, title: '', content: '' } });

    return (
        <div className="mx-auto bg-white rounded-lg ">
            <div className="grid grid-cols-1 px-4 py-2">
                <div>
                    <label className="block font-medium mb-1">Tiêu đề</label>
                    <TextField
                        type="text"
                        placeholder="Nhập tiêu đề"
                        {...register('title')}
                    />
                </div>
                <div className="mt-2">
                    <label className="block font-medium mb-1">Nội dung:</label>
                    <Controller
                        control={control}
                        name="content"
                        render={({ field }) => (
                            <TextAreaCus
                                {...field}
                                className="h-300"
                                style={{ height: 300, paddingBottom: 50 }}
                                placeholder="Nhập nội dung..."
                            />

                        )}
                    />
                </div>

                <div className="content-modal py-4">
                    <Controller
                        control={control}
                        name="file"
                        render={({ field }) => (
                            <ImageUploadWithPreview multiple={false} {...field} onPick={f => field.onChange(f)} />
                        )}
                    />
                </div>
            </div>


            <div className="flex justify-center gap-2 p-4">
                <button
                    onClick={onClose}
                    className="bg-gray-500 text-white px-4 py-1 rounded hover:bg-gray-600"
                >
                    Huỷ
                </button>
                {!!onConfirm && <button
                    onClick={() => handleSubmit(onConfirm)()}
                    className="bg-green-500 text-white px-4 py-1 rounded hover:bg-green-600"
                >
                    Xác nhận
                </button>}
            </div>
        </div>
    );
}
